// extracted by mini-css-extract-plugin
export default {"icon":"Success_icon__E0dJp","BlackSuccessMessege":"Success_BlackSuccessMessege__Dhehs"};